import { cn } from '@/utils/tailwind-util';
import { NavLink, useLocation } from 'react-router-dom';

import SvgIcon from '@/assets/svgIcon';
import { useFetchUserDetail } from '@/services';
import { BellIcon } from '@heroicons/react/outline';
import { useAlarmcenter } from '@/features/alarmcenter/useAlarmcenter';

const Footer = () => {
  const { pathname } = useLocation();
  const rootPath = '/' + pathname.split('/')[1];
  const user = useFetchUserDetail();
  const { stats, isLoading: isAlarmcenterLoading } = useAlarmcenter();
  return (
    <footer className="fixed bottom-0 left-0 right-0 flex justify-between items-center w-full h-16 py-3 bg-white px-8 border-t border-gray-200 z-9999 ">
      <ul className="flex w-full justify-between text-sm text-gray-500">
        {/* <li>
          <NavLink
            to="/task"
            css={[
              tw`hover:text-primary cursor-pointer flex flex-col items-center justify-center`,
              rootPath === '/task' && tw`text-primary`,
            ]}
          >
            <SvgIcon name="clipboard" />
            <span>업무관리</span>
          </NavLink>
        </li> */}
        <li>
          <NavLink
            to="/chat/all"
            className={cn(
              'hover:text-primary cursor-pointer flex flex-col items-center justify-center',
              rootPath === '/chat' && 'text-primary'
            )}
          >
            <SvgIcon name="chat" />
            <span>문의/답변</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/notices"
            className={cn(
              'hover:text-primary cursor-pointer flex flex-col items-center justify-center',
              rootPath === '/notices' && 'text-primary'
            )}
          >
            <SvgIcon name="megaphone" />
            <span>공지사항</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/alarmcenter"
            className={cn(
              'hover:text-primary cursor-pointer flex flex-col items-center justify-center',
              rootPath === '/alarmcenter' && 'text-primary'
            )}
          >
            <div className="relative flex items-center justify-center">
              <BellIcon strokeWidth={1.5} className="w-6 h-6 text-gray-600" />
              {!isAlarmcenterLoading &&
                !!stats?.unread &&
                stats?.unread > 0 && (
                  <p className="absolute translate-x-2 -translate-y-2 text-xs text-white left-1 min-w-5 px-1 py-[2px] bg-red-500 rounded-full">
                    {stats?.unread}
                  </p>
                )}
            </div>
            <span>알림</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/account"
            className={cn(
              'hover:text-primary cursor-pointer flex flex-col items-center justify-center',
              rootPath === '/account' && 'text-primary'
            )}
          >
            <SvgIcon name="user" />
            <span>{user.userPersonalInfo.name || ''}</span>
          </NavLink>
        </li>
      </ul>
    </footer>
  );
};
export default Footer;
